import { armorAPI } from '~/services/api';

export function fetchShippingMethods() {
  return armorAPI.request({
    url: '/user/orders/shipping_methods',
    method: 'GET',
  });
}
